
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/[account_id]/cremation",
      function () {
        return require("private-next-pages/accounts/[account_id]/cremation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/[account_id]/cremation"])
      });
    }
  